module.exports = __webpack_public_path__ + "img/action-log-out.c64ef8c3.png";